import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import { DialogType } from '@/enums/dialogType'

//Componentes
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'

//Grids
import UserGrid from '@/views/Grids/UserGrid.vue'
import PaymentsGrid from '@/views/Grids/PaymentsGrid.vue'
import StockGrid from '@/views/Grids/StockGrid.vue'
import CategoryGrid from '@/views/Grids/CategoryGrid.vue'
import PotGrid from '@/views/Grids/PotGrid.vue'
import CustomerGrid from '@/views/Grids/CustomerGrid.vue'
import ProductGrid from '@/views/Grids/ProductGrid.vue'
import OrderGrid from '@/views/Grids/OrderGrid.vue'
import SellerGrid from '@/views/Grids/SellerGrid.vue'
import StockTransferGrid from '@/views/Grids/StockTransferGrid.vue'

//Relatórios
import StockRelat from '@/views/Relats/StockRelat.vue'
import SalesRelat from '@/views/Relats/SalesRelat.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'clientes',
        name: 'CustomerGrid',
        component: CustomerGrid,
        meta: { title: 'Clientes', permission: 'CUSTOMER' }
      },
      {
        path: 'cliente/edit/:customerId',
        name: 'EditCustomer',
        component: CustomerGrid,
        meta: { title: 'Cliente', permission: 'CUSTOMER' }
      },
      {
        path: 'cliente/novo',
        name: 'NewCustomer',
        component: CustomerGrid,
        meta: { title: 'Cliente', permission: 'CUSTOMER' }
      },
      {
        path: 'categorias',
        name: 'CategoryGrid',
        component: CategoryGrid,
        meta: { title: 'Categorias', permission: 'CATEGORY' }
      },
      {
        path: 'categoria/edit/:categoryId',
        name: 'EditCategory',
        component: CategoryGrid,
        meta: { title: 'Categoria', permission: 'CATEGORY' }
      },
      {
        path: 'categoria/novo',
        name: 'NewCategory',
        component: CategoryGrid,
        meta: { title: 'Categoria', permission: 'CATEGORY' }
      },
      {
        path: 'potes',
        name: 'PotGrid',
        component: PotGrid,
        meta: { title: 'Potes', permission: 'POT' }
      },
      {
        path: 'pote/edit/:potId',
        name: 'EditPot',
        component: PotGrid,
        meta: { title: 'Pote', permission: 'POT' }
      },
      {
        path: 'pote/novo',
        name: 'NewPot',
        component: PotGrid,
        meta: { title: 'Pote', permission: 'POT' }
      },
      {
        path: 'pagamentos',
        name: 'PaymentsGrid',
        component: PaymentsGrid,
        meta: { title: 'Pagamentos', permission: 'PAYMENT' }
      },
      {
        path: 'pagamento/edit/:paymentId',
        name: 'EditPayment',
        component: PaymentsGrid,
        meta: { title: 'Pagamento', permission: 'PAYMENT' }
      },
      {
        path: 'pagamento/novo',
        name: 'NewPayment',
        component: PaymentsGrid,
        meta: { title: 'Pagamento', permission: 'PAYMENT' }
      },
      {
        path: 'estoques',
        name: 'StockGrid',
        component: StockGrid,
        meta: { title: 'Estoques', permission: 'STOCK' }
      },
      {
        path: 'estoque/edit/:stockId',
        name: 'EditStock',
        component: StockGrid,
        meta: { title: 'Estoque', permission: 'STOCK' }
      },
      {
        path: 'estoque/novo',
        name: 'NewStock',
        component: StockGrid,
        meta: { title: 'Estoque', permission: 'STOCK' }
      },
      {
        path: 'usuarios',
        name: 'UserGrid',
        component: UserGrid,
        meta: { title: 'Usuários', permission: 'USER' }
      },
      {
        path: 'usuario/edit/:userId?',
        name: 'EditUser',
        component: UserGrid,
        meta: { title: 'Usuário', permission: 'USER' }
      },
      {
        path: 'usuario/novo',
        name: 'NewUser',
        component: UserGrid,
        meta: { title: 'Usuário', permission: 'USER' }
      },
      {
        path: 'produtos',
        name: 'ProductGrid',
        component: ProductGrid,
        meta: { title: 'Produtos', permission: 'PRODUCT' }
      },
      {
        path: 'produto/edit/:productId?',
        name: 'EditProduct',
        component: ProductGrid,
        meta: { title: 'Produto', permission: 'PRODUCT' }
      },
      {
        path: 'produto/novo',
        name: 'NewProduct',
        component: ProductGrid,
        meta: { title: 'Produto', permission: 'PRODUCT' }
      },
      {
        path: 'vendedores',
        name: 'SellerGrid',
        component: SellerGrid,
        meta: { title: 'Vendedores', permission: 'SELLER' }
      },
      {
        path: 'vendedor/edit/:sellerId?',
        name: 'EditSeller',
        component: SellerGrid,
        meta: { title: 'Vendedor', permission: 'SELLER' }
      },
      {
        path: 'vendedor/novo',
        name: 'NewSeller',
        component: SellerGrid,
        meta: { title: 'Vendedor', permission: 'SELLER' }
      },
      {
        path: 'vendas',
        name: 'OrderGrid',
        component: OrderGrid,
        meta: { title: 'Vendas', permission: 'SALE' }
      },
      {
        path: 'venda/edit/:orderId?',
        name: 'EditOrder',
        component: OrderGrid,
        meta: { title: 'Venda', permission: 'SALE' }
      },
      {
        path: 'venda/novo',
        name: 'NewOrder',
        component: OrderGrid,
        meta: { title: 'Venda', permission: 'SALE' }
      },
      {
        path: 'transferencias',
        name: 'TransferGrid',
        component: StockTransferGrid,
        meta: { title: 'Transferências', permission: 'TRANSFER' }
      },
      {
        path: 'transferencia/edit/:transferId?',
        name: 'EditTransfer',
        component: StockTransferGrid,
        meta: { title: 'Transferência', permission: 'TRANSFER' }
      },
      {
        path: 'transferencia/novo',
        name: 'NewTransfer',
        component: StockTransferGrid,
        meta: { title: 'Transferência', permission: 'TRANSFER' }
      },
      {
        path: '/reports/stock',
        name: 'StockRelat',
        component: StockRelat,
        meta: { title: 'Relatório de estoque', permission: 'STOCK_RELAT' }
      },
      {
        path: '/reports/sales',
        name: 'SalesRelat',
        component: SalesRelat,
        meta: { title: 'Relatório vendas/compras', permission: 'SALE_RELAT' }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    return next()
  }

  const token = localStorage.getItem('token')
  if (!token) {
    return next('/login')
  }

  if (!store.state.user.lstPermissionsLoggedUser.length) {
    store.dispatch('user/loadFromStorage')
  }

  const requiredPermission = to.meta.permission

  if (requiredPermission && !store.getters['user/hasPermission'](requiredPermission)) {
    store.dispatch('systemDialog/show', {
        type: DialogType.WARNING,
        message: 'Você não tem permissão para acessar esta tela.'
    }, { root: true })
    return next(false)
  }

  next()
})

export default router
